import createCollectionResource from 'src/actions/shared/createResource';

// should match AD Agent model src/scripts/domain/models/agent.js
export interface Agent {
  id: string;
  name?: String;
  avatarUrl?: String;
  email?: String;
  twitter?: String;
  disabledAt?: String;
}

const agentsResource = createCollectionResource<Agent>({
  name: 'agents',
  endpoint: 'v1/orgs/:orgId/agents',
});
export default agentsResource;
